import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IRateSourcePromiseLookupService } from "../IRateSourcePromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class RateSourcePromiseLookupService
  extends PromiseLookupService<string, CubiqTS.RateSourceImpl>
  implements IRateSourcePromiseLookupService
{
  constructor() {
    super();
  }

  abstract getRateSource(id: string): Promise<CubiqTS.RateSourceImpl>;
}
